import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { NotificationsApiAdapter } from '../adapters/NotificationsApiAdapter';
import { useAuthStore } from '@shared/stores/authStore';

/**
 * Contador de notificaciones sin leer.
 *
 * No sondea: el estado en vivo llega por el evento de broadcast
 * `notification.emitted` (ver `useNotificationSocket`), que invalida esta query.
 * Aquí solo quedan las dos cargas que el push no cubre: el montaje y la vuelta
 * del foco a la ventana (el default global de React Query es `false`).
 */
export const useUnreadCount = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new NotificationsApiAdapter(httpClient);
  const userId = useAuthStore((state) => state.user?.id);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['notifications', 'unread-count', userId],
    queryFn: () => adapter.getUnreadCount(),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    enabled: !!userId,
  });

  return {
    count: data ?? 0,
    isLoading,
    error,
    refetch,
  };
};
